import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const WrapperStyled = styled(Stack)<{ selected?: boolean }>(
  ({ selected }) => ({
    paddingLeft: selected ? 14 : 16,

    ...(selected && {
      borderLeft: `2px solid ${Colors.blue500}`,
    }),
  })
);

export const HintWrapperStyled = styled('div')(() => ({
  paddingTop: '3px',
}));

export const ContentWrapper = styled(Stack)<{ clickable?: boolean }>(
  ({ clickable }) => ({
    cursor: clickable ? 'pointer' : 'default',

    '.vestion-time': {
      color: Colors.gray600,
    },
    ...(clickable && {
      '&:hover, &:hover .vestion-time': {
        color: Colors.blue700,
      },
    }),
  })
);
